<template>
  <div class="comp-xl-condition-ultra">
    <ly-skeleton v-if="loading" fromType="filter" :highFilter="true"></ly-skeleton>

    <jw-spin v-else :loading="loading" class="rule-form-loading">
      <div class="search-ultra-header" v-if="showHeader">
        <template v-if="data.conditionForm.conditions?.length > 0">
          <div class="search-ultra-header-left">
            <div :class="['search-ultra-header-left-title', headerIsBold ? 'bold' : '']">
              {{ headerTitle }}
            </div>
          </div>
          <div class="search-ultra-header-right">
            <div class="search-ultra-header-right-title">
              <jw-button type="text" size="small" class="clear-all-btn hover-btn" @click="clearAllCondition">清空所有</jw-button>
            </div>
          </div>
        </template>
      </div>
      <jw-form :model="data.conditionForm" ref="editAddForm" class="condition-form">
        <div class="condition-ultra-wrap scrollbar-style-config" ref="searchUltraWrap" :style="{ maxHeight: `${maxHeight}px` }">
          <template v-for="(item, index) in data.conditionForm.conditions" :key="index">
            <div class="condition-ultra-body">
              <jw-row align="center">
                <jw-col :class="index === 0 ? 'condition-title-where' : 'condition-title-where-or'" :span="data.conditionForm.conditions?.length > 1 ? 2 : 0">
                  {{ index === 0 ? outConditionTitle : outMoreConditionTitle }}
                </jw-col>
                <jw-col :span="data.conditionForm.conditions?.length > 1 ? 22 : 24">
                  <div class="condition-inner">
                    <template v-for="(sub, i) in item?.children" :key="i">
                      <jw-row :gutter="4" align="center">
                        <jw-col :span="1" class="condition-title-text" :class="i === 0 ? 'condition-title-where' : 'condition-title-where-or'">
                          {{ i === 0 ? innerConditionTitle : innerMoreConditionTitle }}
                        </jw-col>
                        <!-- 字段 -->
                        <jw-col :span="6">
                          <jw-form-item label-col-flex="0" :field="`conditions.${index}.children.${i}.field`" :rules="formItemRules" class="form-field">
                            <jw-cascader
                              :default-popup-visible="!sub.field && fields?.length && defaultVisible ? true : false"
                              @popup-visible-change="(v) => getPopupIndexFirst(v, sub)"
                              :fallback="(v) => fallbackText(v, sub.fieldConfig)"
                              :placeholder="$t('请选择')"
                              :trigger-props="{
                                updateAtScroll: true,
                                contentClass: 'xl-condition-casacade'
                              }"
                              @change="changeChild($event, sub, index, i)"
                              class="condition-first-select scrollbar-style-config"
                              :style="{ backgroundColor: sub.isFieldEnabled ? 'rgb(var(--danger-1))' : '#fff' }"
                              v-model="sub.field"
                              expand-trigger="click"
                              path-mode
                              :options="fields"
                              :load-more="(option, done) => loadMore(option, done, sub?.fieldInfo, false)"
                            >
                              <template #label>
                                <span :class="{ 'fieldname-enabled': sub.isFieldEnabled }">
                                  {{ sub.fieldConfig?.fieldName }}
                                </span>
                              </template>
                            </jw-cascader>
                          </jw-form-item>
                        </jw-col>
                        <!-- 运算符 -->
                        <jw-col :span="checkOperation(sub) ? 16 : 4">
                          <jw-form-item label-col-flex="0" :field="`conditions.${index}.children.${i}.operation`" :rules="formItemRules" class="form-operation">
                            <jw-select
                              :placeholder="$t('请选择')"
                              @change="changeTwo($event, sub)"
                              class="condition-second-select"
                              v-model="sub.operation"
                              v-if="sub.field"
                              :trigger-props="{
                                updateAtScroll: true,
                                autoFitPopupWidth: false,
                                contentClass: 'search-ultra-filter-select'
                              }"
                            >
                              <jw-option v-for="item in getOperation(sub)" :key="item.value" :value="item?.value">
                                {{ item?.label }}
                              </jw-option>
                              <!-- 特殊处理属于当前值 -->
                              <jw-option :title="item.label" v-if="checkEqCurrent(sub.field) && fromType !== 'fieldSetting'" :value="findAssociation.value">
                                {{ findAssociation.label }}
                              </jw-option>
                            </jw-select>
                          </jw-form-item>
                        </jw-col>

                        <!-- 类型 -->
                        <jw-col :span="!checkOperation(sub) ? 3 : 0">
                          <jw-form-item v-show="sub.field" label-col-flex="0" :field="`conditions.${index}.children.${i}.conditionType`" :rules="formItemRules" class="form-conditionType">
                            <jw-select
                              @change="changeLastChild(sub)"
                              :placeholder="$t('请选择')"
                              class="condition-third-select"
                              v-model="sub.conditionType"
                              :trigger-props="{
                                updateAtScroll: true,
                                autoFitPopupWidth: false,
                                contentClass: 'search-ultra-filter-select'
                              }"
                            >
                              <jw-option :value="0">{{ $t('值') }}</jw-option>
                              <jw-option :value="1">{{ $t('字段') }}</jw-option>
                              <jw-option v-if="needRole?.need && sub.fieldConfig?.fieldType == 6" :value="2">{{ $t('角色') }}</jw-option>
                            </jw-select>
                          </jw-form-item>
                        </jw-col>
                        <!-- 值 -->
                        <jw-col v-if="sub.conditionType === 0" :span="!checkOperation(sub) ? 9 : 0">
                          <jw-form-item v-show="sub.field" label-col-flex="0" :field="`conditions.${index}.children.${i}.value`" :rules="formItemRules" class="form-value">
                            <jw-input :placeholder="$t('请输入')" readonly class="condition-input" v-if="!sub.field" />

                            <template v-else-if="checkSelectFieldType(sub)">
                              <fh-select :multiple="checkMultiple(sub)" v-model.trim="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :options="getOptions(sub)">
                                <template #label="{ data }">
                                  <ly-show-filters showType="condition" :showInner="data.label" />
                                </template>
                              </fh-select>
                            </template>
                            <!-- 6 人员选择是一个单框与角色权限中的添加人员一样 -->
                            <template v-else-if="(sub.fieldConfig?.fieldType == 6 && sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                              <fh-person :multiple="sub.operation === 'equals' || sub.operation === 'not_equals' ? false : true" :isError="personError[`${index}-${i}`]" :maxTagCount="2" :item="sub" @cb="getUserDeptValue($event, index, i)"> </fh-person>
                            </template>
                            <!-- 7数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
                            <template v-else-if="sub.fieldConfig?.fieldType === 7">
                              <jw-input-number class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, getFieldInfo(sub.field))" :formatter="(event) => isShowThousandFormatter(event, getFieldInfo(sub.field))" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(getFieldInfo(sub.field), precisionNum)" />
                            </template>

                            <!-- 日期格式 -->
                            <template v-else-if="sub.fieldConfig?.fieldType == 8">
                              <div class="date-wrapper">
                                <xl-date-variable tagClassName="date-tag-input" :objList="getFieldInfo(sub.field)" :record="sub" @cb="getDateVariable($event, index, i)"></xl-date-variable>
                              </div>
                            </template>
                            <!-- 9日期范围 -->
                            <template v-else-if="sub.fieldConfig?.fieldType === 9">
                              <jw-range-picker v-if="sub.fieldConfig?.fieldExt == '0'" v-model="sub.value" class="rule-form-item-sub-select" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
                              <jw-range-picker v-else-if="sub.fieldConfig?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="sub.value" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
                              <jw-range-picker v-else v-model="sub.value" class="rule-form-item-sub-select" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" popup-container=".system-form-item" :trigger-props="{ updateAtScroll: true }" />
                            </template>

                            <!-- 10 级联选择器 :path-mode="true"-->
                            <template v-else-if="sub.fieldConfig?.fieldType == 10">
                              <jw-cascader :path-mode="true" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" :options="JSON.parse(sub.fieldConfig?.fieldExt)" allow-search v-model="sub.value" :placeholder="$t('请选择')" />
                              <jw-cascader :max-tag-count="1" :path-mode="true" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" :options="JSON.parse(sub.fieldConfig?.fieldExt)" allow-search v-model="sub.value" :placeholder="$t('请选择')" multiple />
                            </template>

                            <!-- 16 金额 -->
                            <template v-else-if="sub.fieldConfig?.fieldType === 16">
                              <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, getFieldInfo(sub.field))" :formatter="(event) => isShowThousandFormatter(event, getFieldInfo(sub.field))" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(getFieldInfo(sub.field), precisionNum)" />
                            </template>

                            <!-- 22 部门 -->
                            <template v-else-if="(sub.fieldConfig?.fieldType == 22 && sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                              <xl-user-depart :maxTagCount="1" @cb="getUserDeptValue($event, index, i)" :isScreen="true" :tree="departTree" style="width: 100%" :sub="sub"></xl-user-depart>
                            </template>

                            <!-- 23百分比 -->
                            <template v-else-if="sub.fieldConfig?.fieldType === 23">
                              <jw-input-number class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, getFieldInfo(sub.field))" :precision="getPrecision(getFieldInfo(sub.field), precisionNum)">
                                <template #append> % </template>
                              </jw-input-number>
                            </template>

                            <!-- 24计算字段 -->
                            <template v-else-if="sub.fieldConfig?.fieldType === 24">
                              <!-- 计算字段的fieldExt的type=5 :数字（汇总累计）type=7 :数字-->
                              <jw-input-number v-if="fieldTypeValidate(sub, [5, 7])" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, getFieldInfo(sub.field))" :formatter="(event) => isShowThousandFormatter(event, getFieldInfo(sub.field))" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(getFieldInfo(sub.field), precisionNum, true)" />
                              <!-- 计算字段的fieldExt的type=6 :金额(汇总金额) type=16 :金额 -->
                              <jw-input-number v-else-if="fieldTypeValidate(sub, [6, 16])" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, getFieldInfo(sub.field))" :formatter="(event) => isShowThousandFormatter(event, getFieldInfo(sub.field))" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(getFieldInfo(sub.field), precisionNum, true)" />
                              <!-- 计算字段的fieldExt的type=0 :文本 -->
                              <jw-input maxLength="200" show-word-limit v-else-if="fieldTypeValidate(sub, [0])" v-model.trim="sub.value" :placeholder="$t('请输入')" class="rule-form-item-sub-select" />
                              <!-- 计算字段的fieldExt的type=23 :百分比 -->
                              <jw-input-number v-else-if="fieldTypeValidate(sub, [23])" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, getFieldInfo(sub.field))" :precision="getPrecision(getFieldInfo(sub.field), precisionNum, true)">
                                <template #append> % </template>
                              </jw-input-number>
                              <!-- 计算字段的fieldExt的type=8 :日期 -->
                              <template v-else-if="fieldTypeValidate(sub, [8])">
                                <xl-date-variable :objList="getFieldInfo(sub.field)" :record="sub" @cb="getDateVariable($event, index, i)"></xl-date-variable>
                              </template>
                            </template>
                            <!-- 单行文本 obj[sub.field] -->
                            <jw-input maxLength="200" show-word-limit v-else v-model.trim="sub.value" :placeholder="$t('请输入')" class="rule-form-item-sub-select" />
                          </jw-form-item>
                        </jw-col>
                        <!-- 角色 全部是多选（即使字段选择等于/不等于，也是多选，后端会按照包含不包含处理）-->
                        <jw-col v-else-if="sub.conditionType === 2" :span="!checkOperation(sub) ? 9 : 0">
                          <jw-form-item v-show="sub.field" label-col-flex="0" :field="`conditions.${index}.children.${i}.value`" :rules="formItemRules" class="form-value">
                            <jw-select :multiple="true" v-model="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true, contentClass: 'search-ultra-filter-select' }" popup-container=".comp-xl-condition-ultra" allow-clear allow-search :max-tag-count="2" :fallback-option="fallbackOption">
                              <template #label="{ data }">
                                <span :class="{ 'error-select': data.isDeleted }">{{ data.label }}</span>
                              </template>
                              <jw-option v-for="item in newRolesList" :key="item.value" :title="item.label" :value="item.value">
                                <span class="option-label">{{ item.label }}</span>
                              </jw-option>
                            </jw-select>
                          </jw-form-item>
                        </jw-col>
                        <jw-col v-else :span="!checkOperation(sub) ? 9 : 0">
                          <!-- 字段 -->
                          <jw-form-item v-show="sub.field" label-col-flex="0" :field="`conditions.${index}.children.${i}.value`" :rules="formItemRules" class="form-value">
                            <jw-cascader
                              :fallback="(v) => fallbackText(v, sub.valueConfig)"
                              @popup-visible-change="(v) => getPopupIndex(v, index, i, sub.cascader)"
                              :placeholder="$t('请选择')"
                              :trigger-props="{
                                updateAtScroll: true,
                                contentClass: 'xl-condition-casacade'
                              }"
                              v-if="sub.field"
                              class="rule-form-item-sub-select"
                              :style="{ backgroundColor: sub.isValueEnabled ? 'rgb(var(--danger-1))' : '#fff' }"
                              v-model="sub.value"
                              expand-trigger="click"
                              path-mode
                              @change="changeCascader($event, sub)"
                              :options="sub.cascader"
                              :load-more="(option, done) => loadMore(option, done, sub?.fieldInfo)"
                            >
                              <template #empty>
                                <jw-empty />
                              </template>
                              <template #label>
                                <span :class="{ 'fieldname-enabled': sub.isValueEnabled }">
                                  {{ sub?.valueConfig?.fieldName }}
                                </span>
                              </template>
                            </jw-cascader>
                            <jw-select :placeholder="$t('请选择')" class="rule-form-item-sub-select" v-else></jw-select>
                          </jw-form-item>
                        </jw-col>

                        <jw-col :span="1" :style="{ padding: '0' }" class="delete-icon-wrap">
                          <span class="handle-icon delete-icon" @click="conditionUpdate(1, index, i)">
                            <icon-delete :size="16" />
                          </span>
                        </jw-col>
                      </jw-row>
                    </template>
                    <div class="add-condition">
                      <jw-button size="small" class="add-condition-btn hover-btn" type="text" @click="conditionUpdate(1, index)">
                        <template #icon>
                          <icon-plus />
                        </template>
                        添加条件
                      </jw-button>
                      <jw-button size="small" v-if="item?.children?.length > 1" class="clear-group hover-btn" type="text" @click="conditionUpdate(0, index)"> 清除组 </jw-button>
                    </div>
                  </div>
                </jw-col>
              </jw-row>
            </div>
          </template>
        </div>
      </jw-form>

      <div :class="['search-ultra-footer', data.conditionForm.conditions?.length > 0 ? '' : 'empty']">
        <div class="footer-left">
          <jw-button type="text" size="small" class="add-group" @click="conditionUpdate(0)">
            <template #icon>
              <icon-plus />
            </template>
            添加条件组
          </jw-button>
        </div>
        <div class="search-ultra-footer" v-if="showFooter">
          <jw-space>
            <slot name="btn"></slot>
            <jw-button class="btn-submit" size="small" type="primary" @click="searchSubmit"> 确认 </jw-button>
          </jw-space>
        </div>
      </div>
    </jw-spin>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, h, computed, inject, nextTick, onUnmounted } from 'vue';
import useLoading from '@/hooks/loading';
import { useI18n } from 'vue-i18n';
import { Message, Input as JwInput } from '@arco-design/web-vue';
import { tools } from '@/utils/tools';
import { formulaFieldService, setService } from '@/api/';
import _ from 'lodash';
// 精度
import useThousandOption from '@/hooks/thousand';
import dayjs from 'dayjs';
import useFields from '@/hooks/fields';

import useUpdateFields from '@/hooks/update-fields';
import FhSelect from '@/components/fh-select/fh-select.vue';
const { checkFilterCondition, initConditionFilter } = useUpdateFields();
const { fieldIconMapping } = useFields();

// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

const { t } = useI18n();
const formItemRules = [{ required: true, message: t('请选择') }];
const emits = defineEmits(['loading']);

const props = defineProps({
  entities: { type: Array }, // 关联实体
  accCondition: { type: Array }, // 关联条件
  filterId: { type: String }, // 过滤ID
  allEntityFields: { type: Array }, // 所有实体字段
  parentEntityId: {
    type: String
  },
  showHeader: {
    type: Boolean,
    default: true
  },
  // 查询他表-过滤第四个选项ID
  sourceFilterId: {
    type: [Number, String],
    default: ''
  },
  // 查询他表-fieldKey
  fieldKey: {
    type: String,
    default: ''
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  headerTitle: {
    type: String,
    default: '条件设置'
  },
  maxHeight: {
    type: Number,
    default: 300
  },
  //显示类型 0.默认 1.包含当前操作人
  showType: {
    type: Number,
    default: 0
  },
  // 是否默认展开第一行
  defaultVisible: {
    type: Boolean,
    default: true
  },
  needRole: {
    type: Object,
    default: () => ({
      need: false,
      rolesList: []
    })
  },
  canDeepSelectNumber: {
    // 是否允许查找关联选择下钻的层级
    type: Number,
    default: 99
  }
});
const findAssociation = {
  label: t('属于当前值'),
  value: 'equals_current_value'
};
const innerConditionTitle = ref('当');
const innerMoreConditionTitle = ref('且');

const outConditionTitle = ref('满足');
const outMoreConditionTitle = ref('或');
const searchUltraWrap = ref(); // 搜索条件容器
const newRolesList = ref([...props.needRole.rolesList]);
// const fieldConfigPath = ref([]); // 字段存储路径
// const valueConfigPath = ref([]); // 值存储路径

// 控制弹窗的显示
const visibleMap = ref({});
const { loading } = useLoading(false);
const editAddForm = ref(null);
const searchText = ref({});
const entity = ref([]);
const filterOption = ref('');
const allFields = ref([]);
const fields = ref([]); // 对象字段
const operations = reactive({}); // 运算符
const objectFormDataMethods = inject('objectFormDataMethods'); //调用父组件方法
// 获取本次布局新增的字段信息
const getTempSettingIds =
  objectFormDataMethods?.gettempSettingIds ||
  (() => {
    return '';
  });
// 获取本次布局禁用的字段信息
const getTempDisableSettingIds =
  objectFormDataMethods?.gettempDisableSettingIds ||
  (() => {
    return '';
  });

const popupIndex = reactive({
  index: null,
  i: null
});

const data = reactive({
  conditionForm: {
    conditions: []
  },
  associationStr: '###',
  routerStr: '@@@',
  currentUser: {
    fieldType: 6,
    fieldKey: 'currentUser'
  },
  currentUserDept: {
    fieldType: 22,
    fieldKey: 'currentUserDept'
  },
  objectAllList: []
});

const checkSelectFieldType = (sub) => {
  return [2, 3, 4, 5].includes(sub.fieldConfig?.fieldType);
};

// 判断是否多选
const checkMultiple = (sub) => {
  return sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == '' ? false : true;
};
// 判断宽度
const checkOperation = (sub) => {
  return sub.operation === 'null' || sub.operation === 'not_null' || sub.operation === 'equals_current_value';
};

// 获取下拉选项
const getOptions = (sub) => {
  return tools.isJSON(sub.fieldConfig?.fieldExt) ? JSON.parse(sub.fieldConfig?.fieldExt) : sub.fieldConfig?.fieldExt;
};

// 加载更多
const loadMore = async (option, done, fieldInfo, isFilterFieldType = true) => {
  console.log('加载更多33');
  if (!allEntityFields.value[option.entity]) {
    // 如果对象字段不存在，则获取对象字段
    // debugger;
    await getAllEntityFields([option.entity]); // 获取对象字段
  }

  const child = getEntityFields(allEntityFields.value[option.entity]?.settings || [], option.valueRouter, {
    type: isFilterFieldType ? fieldInfo?.fieldType ?? null : null,
    fieldExt: fieldInfo?.fieldExt
  });
  option['children'] = child;
  done(child);
};

//等于当前值
const checkEqCurrent = (field) => {
  const fieldInfo = getFieldInfo(field);
  if ([12, 25].includes(fieldInfo?.fieldType)) {
    return JSON.parse(fieldInfo?.fieldExt) == props.parentEntityId;
  }
  return false;
};

// 滚动到最底部
const scrollToBottom = () => {
  nextTick(() => {
    if (searchUltraWrap.value) {
      searchUltraWrap.value.scrollTo({
        top: searchUltraWrap.value?.scrollHeight,
        behavior: 'smooth'
      });
    }
  });
};

//新增或关系
const conditionUpdate = (tp, index, i) => {
  const childCondition = {
    id: undefined,
    operation: '',
    isGroup: false,
    conditionType: 0,
    parentId: undefined,
    field: '',
    value: null,
    fieldInfo: {},
    cascader: []
  };
  if (tp) {
    // 子级
    if (i === undefined) {
      data.conditionForm.conditions[index].children?.push(childCondition);
      const len = data.conditionForm.conditions[index].children?.length;
      visibleMap.value[`${index}-${len - 1}`] = true;
      // 滚动到最底部
      if (index === data.conditionForm.conditions.length - 1) {
        scrollToBottom();
      }
    } else {
      data.conditionForm.conditions[index].children?.splice(i, 1);
      if (!data.conditionForm.conditions[index]?.children?.length) {
        data.conditionForm.conditions?.splice(index, 1);
      }
      visibleMap.value = {};
    }
  } else {
    // 父级
    if (index === undefined) {
      data.conditionForm.conditions?.push({
        id: undefined,
        operation: 'and',
        isGroup: true,
        parentId: undefined,
        children: [
          {
            ...childCondition,
            fieldInfo: {},
            cascader: []
          }
        ]
      });
      const len = data.conditionForm.conditions?.length;
      visibleMap.value[`${len - 1}-0`] = true;
      scrollToBottom();
    } else {
      data.conditionForm.conditions?.splice(index, 1);
      visibleMap.value = {};
    }
  }
};

// 获取运算符
const getOperation = (sub) => {
  const _fi = sub?.fieldConfig;
  let retOperation = [];
  if (_fi?.fieldType !== 24) {
    retOperation = operations?.[_fi?.fieldType];
    if (sub?.field?.[0] === data.currentUser.fieldKey) {
      //如果是特殊的当前操作人 过滤为空和不为空选项，因为使用的是登录人信息，肯定不会出现空和非空
      retOperation = retOperation.filter((item) => !['null', 'not_null'].includes(item.value));
    }
  } else {
    retOperation = operations?.[_fi?.fieldType]?.[tools.isJSON(_fi?.fieldExt) && JSON.parse(_fi?.fieldExt)?.type];
  }

  return retOperation || [];
};

const getFilterFields = (type, fieldInfo) => {
  const _fields = [];
  // sourceFilterId 查询他表-过滤第四个选项ID
  entity.value?.forEach((e) => {
    if (e != props?.sourceFilterId) {
      _fields.push({
        label: allEntityFields.value[e]?.label,
        value: e,
        entity: e,
        valueRouter: e
      });
    }
  });

  if ((type == 6 && fieldInfo?.id) || type == 22) {
    const obj = {
      6: { label: t('属于当前操作人'), value: 'currentUser' },
      22: { label: t('属于当前操作人部门'), value: 'currentUserDept' }
    };
    _fields.push({
      label: obj[type].label,
      value: obj[type].value,
      entity: obj[type].value,
      valueRouter: obj[type].value,
      isLeaf: true
    });
  }
  return _fields;
};

// 清除错误状态
const clearErrorStatus = (index, i, field) => {
  editAddForm.value.setFields({
    [`conditions.${index}.children.${i}.${field}`]: {
      status: 'normal',
      message: ''
    }
  });
};

// ... existing code ...
const getFieldConfig = (path, settings, casecadeList = []) => {
  if (!path || !settings) return '';

  // 处理当前操作人的特殊情况
  if (path[0] === data.currentUser.fieldKey) {
    return t('当前操作人');
  }

  const labels = []; //存储每一级的label
  const fieldPath = []; // 字段存储路径
  let currentOptions = casecadeList; // 当前级别的选项列表
  let currentPath = ''; //当前累计的路径

  // 遍历路径，逐级匹配label
  path.forEach((item, index) => {
    // 构建当前路径
    currentPath = currentPath ? `${currentPath}${data.routerStr}${item}` : item;
    // 在当前级别的选项中查找匹配项
    const matchedOption = currentOptions?.find((option) => option.valueRouter === currentPath);
    if (matchedOption) {
      // 收集标签和实体路径
      labels.push(matchedOption.label); // 存储label
      fieldPath.push(matchedOption.entity); // 存储entity
      // 处理下一级选项
      if (matchedOption.children) {
        // 如果有子级，直接使用子级作为下一级选项
        currentOptions = matchedOption.children;
      } else if (!matchedOption.isLeaf && index < path.length - 1) {
        // 如果没有children但不是叶子节点，需要获取下一级选项
        const entityFields = allEntityFields.value[matchedOption.entity]?.settings || [];
        currentOptions = getEntityFields(entityFields, matchedOption.valueRouter);
      }
    }
  });

  return {
    label: labels.join(' / '),
    fieldPath: fieldPath
  };
};

// ... existing code ...
// 添加一个处理 showText 的方法
const handleShowText = (text) => {
  if (!text) return '';
  const firstSlashIndex = text.indexOf('/');
  if (firstSlashIndex === -1) return text;
  return text
    .slice(firstSlashIndex + 1)
    .trim()
    .replace(/\//g, '.');
};
// 级联选择变化
const changeCascader = (e, sub) => {
  const _fieldInfo = getFieldInfo(sub.value);
  const { label: showText, fieldPath } = getFieldConfig(e, allEntityFields.value[_fieldInfo?.entityId]?.settings, sub.cascader);
  sub.valueConfig = {
    fieldAliases: handleShowText(showText),
    fieldName: showText,
    fieldType: _fieldInfo?.fieldType,
    fieldExt: _fieldInfo?.fieldExt,
    path: fieldPath
  };
  // 字段异常处理 使用 cascader template label 显示 兼容 当前操作人 当前操作部门
  if (e.length == 1 && e[0] == 'currentUser') {
    sub.valueConfig.fieldName = t('当前操作人');
    sub.valueConfig.fieldType = 6;
  }
  if (e.length == 1 && e[0] == 'currentUserDept') {
    sub.valueConfig.fieldName = t('当前操作部门');
    sub.valueConfig.fieldType = 22;
  }
  sub.isValueEnabled = false;
};

const changeChild = (caseValue, sub, index, i) => {
  const _fieldInfo = getFieldInfo(sub.field);

  const { label: showText, fieldPath } = getFieldConfig(caseValue, allEntityFields.value[_fieldInfo?.entityId]?.settings, fields.value);
  sub.fieldConfig = {
    fieldAliases: handleShowText(showText),
    fieldName: showText,
    fieldType: _fieldInfo?.fieldType,
    fieldExt: _fieldInfo?.fieldExt,
    path: fieldPath
  };
  // 字段异常处理 使用 cascader template label 显示 兼容 当前操作人
  if (caseValue.length == 1 && caseValue[0] == 'currentUser') {
    sub.fieldConfig.fieldName = t('当前操作人');
    sub.fieldConfig.fieldType = 6;
  }
  sub.field = caseValue;
  sub.fieldInfo = _fieldInfo;
  sub.cascader = getFilterFields(_fieldInfo?.fieldType, _fieldInfo);
  sub.operation = '';
  sub.conditionType = 0;
  sub.value = null;
  sub.userDept = [];
  sub.departList = [];
  sub.userList = [];
  sub.business = null;
  sub.userDeptIds = null;
  sub.isFieldEnabled = false;

  if (caseValue) {
    // 设置默认的 operation 值
    const operationsObj = operations?.[_fieldInfo?.fieldType]; // 可用的运算符
    if (_fieldInfo?.fieldType === 24) {
      //计算字段
      const fieldExt = tools.isJSON(_fieldInfo?.fieldExt) ? JSON.parse(_fieldInfo?.fieldExt) : null;
      const type = fieldExt?.type;
      if ((type || type === 0) && operationsObj?.[type]?.length > 0) {
        sub.operation = operationsObj[type][0].value;
        sub.operationName = operationsObj[type][0]?.label;
      }
    } else {
      if (Array.isArray(operationsObj) && operationsObj.length > 0) {
        sub.operation = operationsObj[0].value;
        sub.operationName = operationsObj[0]?.label;
      }
    }
    clearErrorStatus(index, i, 'operation');
  }
};

const changeTwo = (e, sub) => {
  const fieldInfo = sub.fieldInfo;
  const operation = operations?.[fieldInfo?.fieldType];
  sub.conditionType = 0;
  sub.operation = e;
  sub.value = null;
  sub.userDept = [];
  sub.departList = [];
  sub.userList = [];
  sub.userDeptIds = null;
  sub.operationName = operation.find((item) => item.value == e)?.label;
};

const changeLastChild = (sub) => {
  if (sub.conditionType == 1 && sub.field?.length > 0) {
    const _fi = getFieldInfo(sub.field);
    sub.fieldInfo = _fi;
    sub.cascader = getFilterFields(_fi?.fieldType, _fi);
  }
  sub.value = null;
  sub.userDept = [];
  sub.departList = [];
  sub.userList = [];
  sub.userDeptIds = null;
};
const cpcasecader = ref();

const getPopupIndex = (v, index, i, cascader) => {
  const conditionItem = data.conditionForm.conditions[index].children[i];
  if (v) {
    popupIndex.index = index;
    popupIndex.i = i;
    cpcasecader.value = _.cloneDeep(cascader);
  } else {
    popupIndex.index = null;
    popupIndex.i = null;
    searchText.value = {};
    conditionItem.cascader = cpcasecader.value;
  }
};

const fallbackText = (v, subConfig) => {
  return subConfig?.fieldName;
};

const getValueRouter = (vr, str) => {
  return `${vr}${data.routerStr}${str}`;
};

const getFieldInfo = (f, i = 0, entity = null) => {
  //如果是用户选择了当前操作人 就直接返回预设字段数据
  if (i == 0 && f?.[0] === data.currentUser.fieldKey) return data.currentUser;
  if (i == 0 && f?.[0] === data.currentUserDept.fieldKey) return data.currentUserDept;

  entity = entity === null ? f[0] : entity;
  const isLeaf = f[i + 1].indexOf(data.associationStr) > -1 ? false : true;
  const _field = f[i + 1].replace(data.associationStr, '');
  let ret = {};

  allEntityFields.value[entity]?.settings.forEach((afc) => {
    if (afc.fieldKey == _field) {
      if (isLeaf) {
        if (afc.fieldType == 21) {
          ret = {
            ...afc,
            fieldType: afc?.setting?.business?.fieldType,
            fieldExt: afc?.setting?.business?.fieldExt
          };
        } else {
          ret = afc;
        }
      } else {
        ret = getFieldInfo(f, i + 1, parseInt(afc.fieldExt));
      }
    }
  });

  // 过滤生命状态字段的 已作废
  if (ret.fieldType == '4' && ret.fieldKey == 'status' && tools.isJSON(ret.fieldExt)) {
    const fieldExtArray = JSON.parse(ret.fieldExt)?.filter((e) => e.value != '4');
    ret.fieldExt = JSON.stringify(fieldExtArray);
  }

  return ret;
};

const formatSearchChild = (data, v, vr, type = null) => {
  // data: 级联数据
  // v: 搜索值
  // vr: 搜索值路由
  // type: 类型
  data.forEach((f) => {
    if (f.value == vr[0]) {
      const entityFields = allEntityFields.value[f.entity]?.settings || [];
      const fields = getEntityFields(entityFields, f.valueRouter, type);

      if (vr.length == 1) {
        f.children = v === '' ? fields : fields.filter((c) => c.label.indexOf(v) > -1 || c.value == 'input');
      } else {
        vr.shift(); // 保留原数组修改行为
        formatSearchChild(f.children || [], v, vr, type);
      }
    }
  });
};

const searchFields = (v, vr) => {
  const _vr = (vr + '').split(data.routerStr);

  if (popupIndex.index !== null && popupIndex.i !== null) {
    //搜索最后一个选项

    const handleItem = data.conditionForm.conditions[popupIndex.index].children[popupIndex.i];

    const _fi = getFieldInfo(handleItem.field);

    formatSearchChild(handleItem.cascader, v, _vr, {
      type: _fi?.fieldType,
      fieldExt: _fi?.fieldExt
    });
  } else {
    formatSearchChild(fields.value, v, _vr, null);
  }
};

const fieldTypeValidate = (sub, fieldTypes = []) => {
  const _fi = getFieldInfo(sub?.field);
  return (tools.isJSON(_fi?.fieldExt) && fieldTypes?.includes(JSON.parse(_fi?.fieldExt)?.type)) || (tools.isJSON(_fi?.business?.fieldExt) && fieldTypes?.includes(JSON.parse(_fi?.business?.fieldExt)?.type));
};

// 生成级联数据
const getEntityFields = (d, valueRouter, type = null) => {
  const _data = [];
  let fieldExt = null;
  if (typeof type == 'object' && type !== null) {
    fieldExt = type?.fieldExt;
    type = type?.type;
  }
  const inputVR = getValueRouter(valueRouter, 'input');
  _data.push({
    value: 'input',
    label: t('搜索'),
    valueRouter: inputVR,
    isLeaf: true,
    disabled: true,
    render: () => {
      return h(JwInput, {
        placeholder: t('搜索'),
        size: 'small',
        inputAttrs: { id: inputVR, value: searchText.value?.[inputVR] || '' },
        onClick: () => {
          const element = document.getElementById(inputVR);
          if (document.activeElement !== element) {
            element.focus();
          }
        },
        onInput: (e) => {
          searchText.value[inputVR] = e;
          searchFields(e, valueRouter);
        }
      });
    }
  });
  // d.filter((dItem) => !props.filterFieldType.includes(dItem.fieldType)).map((v) => {
  d.map((v) => {
    const cmpName = fieldIconMapping.value[Number(v.fieldType)];
    if (![18, 21].includes(v.fieldType) && (type === null || (v.fieldType == type && ((type != 12 && type != 25) || fieldExt == v.fieldExt)) || (v.fieldType == 12 && type == 25 && fieldExt == v.fieldExt) || (v.fieldType == 25 && type == 12 && fieldExt == v.fieldExt))) {
      _data.push({
        value: v.fieldKey,
        entity: v.entityId,
        label: v.fieldName,
        valueRouter: getValueRouter(valueRouter, v.fieldKey),
        filterType: type,
        isLeaf: true,
        render: () => {
          return h(
            'div',
            {
              class: 'render-cascade'
            },
            h(cmpName),
            v.fieldName
          );
        }
      });
    }

    const routerFlag = `${data.routerStr}${data.associationStr}`; // 层级路由标记
    const selectNumber = valueRouter ? String(valueRouter)?.split(routerFlag)?.length : 0; // 获取当前层级
    if (v.fieldType == 12 && props.canDeepSelectNumber > selectNumber) {
      _data.push({
        value: `${data.associationStr}${v.fieldKey}`,
        entity: v.fieldExt,
        valueRouter: getValueRouter(valueRouter, `${data.associationStr}${v.fieldKey}`),
        label: v.fieldName,
        filterType: type,
        render: () => {
          return h(
            'div',
            {
              class: 'render-cascade'
            },
            h(cmpName),
            v.fieldName
          );
        }
      });
    }
  });

  if (_data.length === 1) {
    //只有一个搜索
    _data.shift();
  }
  // debugger;

  return _data;
};

// 人员配置
// const userTree = ref({
//   checkDepartment: false,
//   isAll: false
// });

// 部门配置
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});

// 日期类型获取日期变量
const getDateVariable = (record, index, i) => {
  data.conditionForm.conditions[index].children[i].value = record;
  clearErrorStatus(index, i, 'value');
};

//人员 部门 获取值
const getUserDeptValue = (v, index, i) => {
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  const conditionItem = data.conditionForm.conditions[index].children[i];
  conditionItem.userDept = [...userNames.value, ...departNames.value];
  conditionItem.userList = v.userList;
  conditionItem.departList = v.departList;
  const userIds = conditionItem.userList?.map((c) => c.id);
  const departIds = conditionItem.departList?.map((c) => c.id);

  conditionItem.value = JSON.stringify({
    userIds,
    departIds
  });

  const userIdInfoList = v.userList?.map((uItem) => {
    return {
      id: uItem.id,
      name: uItem.userName,
      avatar: uItem.avatarOrigin
    };
  });
  const departInfoList = v.departList?.map((uItem) => {
    return {
      id: uItem.id,
      name: uItem.departmentName
    };
  });
  conditionItem.business = {
    userIds: userIdInfoList,
    departIds: departInfoList
  };

  if (conditionItem.operation === 'equals' || conditionItem.operation == 'not_equals') {
    if (conditionItem.userDept.length > 1) {
      Message.warning(t('请注意，只可选择一个人员或部门哦'));
    }
  }

  personError.value[`${index}-${i}`] = false;

  clearErrorStatus(index, i, 'value');
};
// 获取角色异常数据
const fallbackOption = (value) => {
  return {
    label: value + (newRolesList.value?.length ? `（${t('角色异常')}）` : ''),
    value: value,
    isDeleted: true
  };
};
// // 角色是否显示错误状态
// const isShowError = (sub) => {
//   console.log('isShowError', sub);
//   // 提取newRolesList中已存在的value值，用于快速查找
//   const existingValues = new Set(newRolesList.value.map((item) => item.value));
//   //sub是个数组，比如[12,13,14,15] 遍历sub中的所有项，如果当前项不存在于existingValues中，则返回true否则返回false
//   return sub.some((value) => !existingValues.has(value));
// };
//获取运算符
const getConditionOperation = async () => {
  try {
    if (!entitiesCmp.value?.length) return;
    const json = await setService.getDynamic({ apiIndex: Math.random() });
    if (!json.error) {
      json.result.forEach((item) => {
        // operations[item.fieldType] = item.conditions; //第二个框
        if (item.fieldType == 24) {
          operations[item.fieldType] = item.computeMaps; //第二个框
        } else {
          operations[item.fieldType] = item.conditions; //第二个框
        }
      });
    }
  } catch (e) {
    console.log(e);
  }
};

//初始化级联数据
const initFields = () => {
  const _fields = [];
  entity.value
    ?.filter((e) => filterOption.value == '' || e != filterOption.value)
    .forEach((e) => {
      _fields.push({
        label: allEntityFields.value[e]?.label,
        value: e,
        entity: e,
        valueRouter: e
      });
    });

  if (props.showType === 1) {
    //添加当前操作人选项
    _fields.push({
      filterType: null,
      isLeaf: true,
      label: '当前操作人',
      value: data.currentUser.fieldKey,
      valueRouter: data.currentUser.fieldKey
    });
  }
  fields.value = _fields;
  copyFields.value = _.cloneDeep(fields.value);
};

const copyFields = ref();

//字段级联点开初始化
const getPopupIndexFirst = async (v) => {
  if (v) {
    // 打开弹窗
    copyFields.value = _.cloneDeep(fields.value);
  }

  if (!v) {
    // 恢复级联数据
    searchText.value = {};
    if (copyFields.value) {
      fields.value = _.cloneDeep(copyFields.value);
    }
  }
};

const allEntityFields = ref({}); // 所有启用字段信息
const allEntityFieldsCopy = ref({}); // 所有字段信息
// 已停用的字段集合
const disabledAllEntityFields = computed(() => {
  const disabledFields = [];
  Object.keys(allEntityFieldsCopy.value).forEach((key) => {
    allEntityFieldsCopy.value[key]?.settings?.forEach((item) => {
      // isEnabled = false  该字段停用
      if (item?.isEnabled === false) disabledFields.push(item?.fieldKey);
    });
  });
  return Array.from(new Set(disabledFields));
});

//获取对象字段
const getAllEntityFields = async (entityPath) => {
  try {
    if (!entityPath?.length) return;
    const params = {
      entities: entityPath,
      showDisabled: true
    };

    params.tempSettingIds = getTempSettingIds?.();

    params.tempDisableSettingIds = getTempDisableSettingIds?.();

    const res = await formulaFieldService.getEntitySettings(params);

    if (!res.error) {
      entityPath.forEach((entityItem) => {
        const resultEntityItem = res.result[entityItem];
        // 遍历存储数据  props.fieldKey  查询他表等场景 过滤该字段
        allEntityFieldsCopy.value[entityItem] = {
          ...resultEntityItem,
          settings: resultEntityItem.settings
        };
        allEntityFields.value[entityItem] = {
          ...resultEntityItem,
          settings: resultEntityItem.settings.filter((rrcf) => rrcf?.isEnabled && rrcf?.fieldType != 26 && rrcf?.fieldType != 27 && (resultEntityItem.entityType != 16 || rrcf?.fieldKey != 'businessId'))
        };
        if (props.fieldKey) {
          allEntityFields.value[entityItem].settings = allEntityFields.value[entityItem].settings?.filter((item) => item.fieldKey != props.fieldKey);
        }
      });
    } else {
      Message.error(res?.msg || res?.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(e);
  }
};

const initCascadeData = (d, f, index, i, j = 0, type = null) => {
  //初始化第一个级联数据
  d.forEach((dv) => {
    if (dv.value == f[j]) {
      if ((!dv?.children || !dv?.children?.length) && j != f.length - 1) {
        const handleChildItem = allEntityFields.value[Number(dv.entity)]?.settings || [];

        dv['children'] = getEntityFields(handleChildItem, dv.valueRouter, type);
      }
      j++;
      if (j < f.length) {
        initCascadeData(dv.children, f, index, i, j, type);
      }
    }
  });
};

//格式化级联数据
const formatCondition = async (condition) => {
  const _condition = JSON.parse(JSON.stringify(condition));
  const requestPath = [];

  _condition.forEach((con) => {
    con.children.forEach((c) => {
      if (c?.fieldConfig?.path) {
        requestPath.push(...c.fieldConfig.path);
      }
      if (c?.valueConfig?.path) {
        requestPath.push(...c.valueConfig.path);
      }
    });
  });

  // 假设比较对象的 id 属性
  const diffPaths = requestPath.filter((path) => !entity.value.some((item) => Number(item) === Number(path)));

  if (diffPaths.length) {
    await getAllEntityFields(Array.from(new Set(diffPaths)));
  }
  _condition.forEach((con, m) => {
    con.children.forEach(async (c, n) => {
      // 遍历获取对象数据，如果对象数据不存在，则获取对象数据

      const isFieldArray = Array.isArray(c.field);
      const isValueArray = Array.isArray(c.value);
      const isConditionType1 = c.conditionType === 1;

      if (isFieldArray) {
        c.field.forEach((cf, i) => {
          if (i !== 0 && i !== c.field.length - 1) {
            c.field[i] = `${data.associationStr}${cf}`;
          }
        });

        c.fieldInfo = getFieldInfo(c.field);

        initCascadeData(fields.value, c.field, m, n);
      }

      if (isConditionType1 && isValueArray) {
        c.value.forEach((cv, j) => {
          if (j !== 0 && j !== c.value.length - 1) {
            c.value[j] = `${data.associationStr}${cv}`;
          }
        });

        c.cascader = getFilterFields(c.fieldInfo?.fieldType, c.fieldInfo);

        initCascadeData(c.cascader, c.value, m, n, 0, {
          type: c.fieldInfo?.fieldType,
          fieldExt: c.fieldInfo?.fieldExt
        });
      }
    });
  });
  return _condition;
};

const entitiesCmp = computed(() => props.entities);
const accConditionCmp = computed(() => props.accCondition);
const filterIdCmp = computed(() => props.filterId);

//抛出数据
const setCondition = () => {
  const _branches = JSON.parse(JSON.stringify(data.conditionForm.conditions));
  _branches.forEach((v) => {
    v.children.forEach((c) => {
      // 处理字段
      if (Array.isArray(c.field)) {
        for (let i = 1; i < c.field.length; i++) {
          c.field[i] = c.field[i].replace(data.associationStr, '');
        }
      }

      // 处理值
      if (c.conditionType === 1 && Array.isArray(c.value)) {
        for (let i = 1; i < c.value.length; i++) {
          c.value[i] = c.value[i].replace(data.associationStr, '');
        }
      }
    });
  });

  checkFilterCondition({ _condition: _branches });

  return _branches;
};

// 清空所有
const clearAllCondition = () => {
  data.conditionForm.conditions = [];
};

// 表单校验
const formValidateFn = (cIndex, vIndex, field) => {
  editAddForm.value.setFields({
    [`conditions.${cIndex}.children.${vIndex}.${field}`]: {
      status: 'error',
      message: ''
    }
  });
};

// 表单校验
const validateForm = async () => {
  const errors = await editAddForm.value.validate();
  if (errors) {
    // 校验失败
    return false;
  }
  return true;
};

const personError = ref({});

// 校验表单
const formValidate = async () => {
  let isValid = true;
  let firstErrorField = null;
  const conditionResult = setCondition();

  if (!conditionResult?.length && props.sourceFilterId) {
    isValid = false;
  }
  const setFirstErrorField = (field) => {
    if (!firstErrorField) {
      firstErrorField = field;
    }
  };

  const validateField = (conditionIdx, childIdx, fieldKey) => {
    formValidateFn(conditionIdx, childIdx, fieldKey);
    setFirstErrorField(`conditions.${conditionIdx}.children.${childIdx}.${fieldKey}`);
    isValid = false;
  };

  conditionResult.forEach((cItem, cIndex) => {
    cItem.children?.forEach((vItem, vIndex) => {
      if (!vItem.field) {
        validateField(cIndex, vIndex, 'field');
      }

      if (vItem.operation !== 'equals_current_value') {
        //特殊处理 属于当前值没有后续选项
        if (!vItem.operation) {
          validateField(cIndex, vIndex, 'operation');
        }
        if (vItem.operation !== 'null' && vItem.operation !== 'not_null') {
          const isUserOrDeptField = [6, 22].includes(vItem.fieldInfo.fieldType);
          if (isUserOrDeptField && vItem.conditionType === 0) {
            // 值
            if (!vItem.userDept.length) {
              personError.value[`${cIndex}-${vIndex}`] = true;
              validateField(cIndex, vIndex, 'value');
            }
          } else if (!vItem.value && vItem.value !== 0) {
            // 字段
            validateField(cIndex, vIndex, 'value');
          }
        }
      }
    });
  });

  if (firstErrorField) {
    nextTick(() => {
      editAddForm.value.scrollToField(firstErrorField);
    });
  }
  const validate = await validateForm();
  return isValid && validate;
};

const getAllConditions = async (isRequired = true) => {
  if (isRequired) {
    const error = await formValidate();
    if (!error) {
      // 校验失败
      Message.warning('请完善筛选条件');
      return false;
    }
  }
  return setCondition();
};

//初始化条件
const conditionInit = async () => {
  loading.value = true;
  data.conditionForm.conditions = [];
  const uniqueEntity = Array.from(new Set(entitiesCmp.value)); //数组去重 关联当前自己对象兼容
  entity.value = uniqueEntity;
  //如果长度大于1，那么关联的肯定不是自己，则过滤条件，否则关联自己，不在过滤自己

  if (uniqueEntity.length > 1) {
    filterOption.value = filterIdCmp.value;
  } else {
    filterOption.value = '';
  }
  searchText.value = {};
  // await getRuleObjList(); // 获取所有对象列表
  Promise.all([
    await getConditionOperation(), // 获取操作项
    await getAllEntityFields(entity.value)
  ]);
  initFields(); // 初始化级联数据

  if (accConditionCmp.value && accConditionCmp.value.length) {
    const initConditions = initConditionFilter(accConditionCmp.value, allFields.value, uniqueEntity[1]);
    data.conditionForm.conditions = await formatCondition(initConditions);
  } else {
    data.conditionForm.conditions.push({
      id: undefined,
      operation: 'and',
      isGroup: true,
      parentId: undefined,
      children: [
        {
          id: undefined,
          operation: '',
          isGroup: false,
          conditionType: 0,
          parentId: undefined,
          field: '',
          value: null,
          fieldInfo: {},
          cascader: []
        }
      ]
    });
    nextTick(() => {
      visibleMap.value['0-0'] = true;
    });
  }

  loading.value = false;
  emits('loading', loading.value);
};

// 获取对象下拉列表
const getAllObjList = async () => {
  try {
    data.objectAllList = []; //全部对象
    const res = await setService.getRuleObjList({ existDisableEntity: true });
    if (!res.error) {
      data.objectAllList = res?.result || [];
    }
  } catch (e) {
    console.log('错误', e);
  }
};

// 校验字段是否停用
const checkFieldEnabled = () => {
  if (data.conditionForm.conditions?.length) {
    data.conditionForm.conditions?.forEach((item) => {
      if (item.children?.length) {
        item.children?.forEach((sub) => {
          sub.isFieldEnabled = false;
          sub.isValueEnabled = false;
          // 左侧
          if (sub?.field && Array.isArray(sub?.field)) {
            const _arrayfield = sub?.field?.filter((item) => !item.startsWith('###'));
            // 校验字段是否停用
            const resultField = _arrayfield?.filter((item) => disabledAllEntityFields.value.includes(item));
            // 校验对象是否停用
            const resultObj = data.objectAllList?.find((item) => _arrayfield?.[0] == item.value);
            if (resultField?.length || resultObj?.isEnabled == false) {
              sub.isFieldEnabled = true;
              sub.fieldConfig.fieldName = sub.fieldConfig.fieldName + ' (已停用)';
            }
          }
          // 右侧
          if (sub?.value && Array.isArray(sub?.value)) {
            const _arrayValue = sub?.value?.filter((item) => !item.startsWith('###'));
            // 校验字段是否停用
            const resultValue = _arrayValue?.filter((item) => disabledAllEntityFields.value.includes(item));
            // 校验对象是否停用
            const resultObjValue = data.objectAllList?.find((item) => _arrayValue?.[0] == item.value);
            if (resultValue?.length || resultObjValue?.isEnabled == false) {
              sub.isValueEnabled = true;
              sub.valueConfig.fieldName = sub.valueConfig.fieldName + ' (已停用)';
            }
            // 校验角色已选择是否删除
            // const subIds = Array.isArray(sub.value) ? sub.value : [];
            // // 提取newRolesList中已存在的value值，用于快速查找
            // const existingValues = new Set(newRolesList.value.map((item) => item.value));
            // // 遍历sub.value中的所有id
            // subIds.forEach((id) => {
            //   // 如果当前id不在现有列表中，则添加标记项
            //   if (!existingValues.has(id)) {
            //     newRolesList.value.push({
            //       value: id,
            //       label: '该角色已删除',
            //       isDeleted: true
            //     });
            //     // 将新添加的id加入集合，避免重复添加
            //     existingValues.add(id);
            //   }
            // });
          }
        });
      }
    });
  }
};

//初始化
onMounted(async () => {
  await conditionInit();
  await getAllObjList();
  checkFieldEnabled();
});

//卸载
onUnmounted(() => {
  allEntityFields.value = {};
  allEntityFieldsCopy.value = {};
});

defineExpose({
  getAllConditions
});
</script>
<style scoped lang="less">
@import './qf-condition-ultra.less';
</style>

<style lang="less">
// 条件组件级联合组件特殊样式处理
.xl-condition-casacade {
  .render-cascade {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .arco-select-dropdown-list-wrapper {
    overflow-y: scroll;
  }

  .arco-cascader-panel-column {
    // width: 180px;
    padding: 4px 0;
  }

  .arco-cascader-dropdown-panel {
    .arco-cascader-panel-column:nth-of-type(n + 2) {
      .arco-cascader-list {
        li:first-of-type {
          // 级联框样式
          .arco-cascader-option-label {
            padding: 0;

            .arco-input-error {
              background-color: var(--color-fill-2);
            }
          }
        }
      }
    }
  }

  .arco-cascader-list {
    padding: 0 8px;
  }

  .arco-input-wrapper {
    height: 100%;
  }

  .arco-cascader-option {
    height: 32px;
    line-height: 32px;
  }

  // .arco-cascader-option-label {
  //   padding: 0 8px;
  // }
  .arco-scrollbar-thumb {
    opacity: 0.8;

    .arco-scrollbar-thumb-bar {
      background-color: var(--color-fill-2);
    }

    &:hover {
      .arco-scrollbar-thumb-bar {
        background-color: var(--color-fill-3);
      }
    }
  }

  .arco-scrollbar-track-direction-vertical {
    width: 6px;

    .arco-scrollbar-thumb-bar {
      width: 6px;
      margin: 0;
    }
  }
}
</style>
